import Api from '../../config/api-endpoints'
export function UPLOAD_STUDENT_IMAGE() {
  return {
    url: `${Api.storageApiURL}/upload/area-logada/student/image/`,
    options: {
      headers: {
        'Content-Type': 'image/*',
      },
    },
  }
}
